import axios from "axios";
import { BASE_URL_REPORTS } from "./apiConfig";
import { getToken, getStoreId } from "./helper";

export const REPORT_API = axios.create({
  baseURL: BASE_URL_REPORTS,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

REPORT_API.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    } else {
      config.headers["Authorization"] = null;
    }
    const storeId = getStoreId();
    if (storeId) {
      config.headers.common["X-STORE"] = storeId;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

REPORT_API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/authentication/login";
    }
    return Promise.reject(error);
  }
);
